import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-[10px] font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 uppercase tracking-wider",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary: "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive: "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground",
        success: "border-emerald-500/30 bg-emerald-50 text-emerald-700 hover:bg-emerald-100/80 dark:bg-emerald-500/10 dark:text-emerald-400",
        warning: "border-amber-500/30 bg-amber-50 text-amber-700 hover:bg-amber-100/80 dark:bg-amber-500/10 dark:text-amber-400",
        error: "border-red-500/30 bg-red-50 text-red-700 hover:bg-red-100/80 dark:bg-red-500/10 dark:text-red-400",
        info: "border-sky-500/30 bg-sky-50 text-sky-700 hover:bg-sky-100/80 dark:bg-sky-500/10 dark:text-sky-400",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> { }

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
